import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('groundedStatusBadge');

    return {
        GROUNDED: t('grounded')
    };
};

export default useTranslation;
